'use strict';

angular.module('shiftTraderApp')
  .factory('AccountTransactions', function (ServerUrls, $http, $q) {
    var path = ServerUrls.current.railsApi + 'account_transactions/';

    var AccountTransactions = {};

    AccountTransactions.getByOrgId = function(orgId, options) {
      var config = {
        params: {
          organization_id: orgId
        }
      };

      if (angular.isDefined(options)) {
        angular.extend(config.params, options);
      }
      return $http.get(path, config)
        .then(function(response) {
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };

    return AccountTransactions;
  });
